import { qs, listen } from "@fluorescent/dom";
import { emit } from "@/glow/events";

export default function (container) {
  const quantityWrapper = qs(".quantity-input", container);
  if (!quantityWrapper) return;
  const quantityInput = qs("[data-quantity-input]", quantityWrapper);
  const addQuantity = qs("[data-add-quantity]", quantityWrapper);
  const subtractQuantity = qs("[data-subtract-quantity]", quantityWrapper);

  const minQuantity = parseInt(quantityInput.getAttribute("min"), 10);
  const step = parseInt(quantityInput.getAttribute("step"), 10);
  const maxQuantity = parseInt(quantityInput.getAttribute("max"), 10);

  const handleAddQuantity = () => {
    const currentValue = parseInt(quantityInput.value, 10);
    const newQuantity = currentValue + step;

    if (maxQuantity) {
      quantityInput.value = Math.min(newQuantity, maxQuantity);
    } else {
      quantityInput.value = newQuantity;
    }

    quantityInput.dispatchEvent(new Event("change"));
  };

  const handleSubtractQuantity = () => {
    const currentValue = parseInt(quantityInput.value);
    const newQuantity = currentValue - step;

    quantityInput.value = Math.max(newQuantity, minQuantity);
    quantityInput.dispatchEvent(new Event("change"));
  };

  const handleInputChange = () => {
    const currentQuantity = parseInt(quantityInput.value, 10);

    if (step) {
      // round up to the nearest step. checks against minQuantity to allow for a `0` in the cart.
      const roundedQuantity = Math.ceil(currentQuantity / step) * step;
      const newQuantity = maxQuantity
        ? Math.min(Math.max(roundedQuantity, minQuantity), maxQuantity)
        : Math.max(roundedQuantity, minQuantity);

      quantityInput.value = newQuantity;
    }

    if (isNaN(currentQuantity)) {
      quantityInput.value = minQuantity;
    }

    setTimeout(() => emit("quantity:force-change"), 100);
    updateQuantityButtons();
  };

  const updateQuantityButtons = () => {
    const currentQuantity = parseInt(quantityInput.value, 10);

    subtractQuantity.toggleAttribute(
      "disabled",
      currentQuantity === minQuantity
    );
    addQuantity.toggleAttribute("disabled", currentQuantity === maxQuantity);
  };

  // update on load
  updateQuantityButtons();

  const events = [
    listen(addQuantity, "click", handleAddQuantity),
    listen(subtractQuantity, "click", handleSubtractQuantity),
    listen(quantityInput, "change", handleInputChange),
  ];

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
}
